export function isUploadedToS3(value: string): boolean {
    return (value || '').toLowerCase().includes('s3staticfiles');
}
